import React, { Component } from "react";
import { Card, Input, Button, Select, Table } from "antd";

import { connect } from "react-redux";
import {
  req_page_gqm_reportSurvey,
  req_downloadfile_gqm_reportSurvey,
  req_downloadfile_gqm_reportSurveyLottery,
} from "../../api";

import { formateDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { getGraduateAcademicYear } from "../../utils/dateUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";

class SurverYearReport extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    userLevel: "NORMAL",
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "YearSurvey",
    searchValue: "1",
    filterStatus: getGraduateAcademicYear(new Date()) - 1,
    loading: false,
    domnloadFile: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true });
    const result = await req_page_gqm_reportSurvey(
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    // console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async (type) => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl =
      type === "REPORT"
        ? await req_downloadfile_gqm_reportSurvey(
            userCode,
            userLevel,
            searchField,
            searchValue,
            filterStatus,
            token
          )
        : await req_downloadfile_gqm_reportSurveyLottery(
            userCode,
            userLevel,
            searchField,
            searchValue,
            filterStatus,
            token
          );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download =
      type === "REPORT" ? "畢業生流向調查結果" : "畢業生流向調查抽獎名單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "調查區間",
        dataIndex: "YearSurvey",
        width: 100,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學年度",
        dataIndex: "YearGrade",
        width: 100,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學號",
        dataIndex: "AlumniCode",
        width: 100,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "AlumniName",
        width: 100,
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "調查日期",
        dataIndex: "RecordCreateDateTime",
        width: 100,
        responsive: ["md"],
        render: (text, record) => (
          <>
            <span>{formateDate(text)}</span>
          </>
        ),
      },
      {
        title: "問卷版本",
        dataIndex: "Version",
        width: 100,
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_download = (type) => {
    this.api_downloadfile_items(type);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const { loading, items, pagination, searchValue, filterStatus } =
      this.state;
    const title = (
      <>
        <span>調查年度</span>
        <Input
          placeholder="畢業學年度"
          style={{
            width: 80,
            margin: "0 5px",
            backgroundColor: "lightyellow",
          }}
          value={filterStatus}
          onChange={(event) =>
            this.setState({ filterStatus: event.target.value })
          }
        />
        <Select
          value={searchValue}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchValue: value })}
          key={searchValue}
        >
          <Select.Option value="NONE">調查區間</Select.Option>
          <Select.Option value="1">畢業一年</Select.Option>
          <Select.Option value="3">畢業三年</Select.Option>
          <Select.Option value="5">畢業五年</Select.Option>
        </Select>
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_data_download("REPORT")}
        >
          <i className="fas fa-file-download"></i>
          <span style={{ marginLeft: "4px" }}>報表下載</span>
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_data_download("LOTTERY")}
        >
          <i className="fas fa-download"></i>
          <span style={{ marginLeft: "4px" }}>抽獎下載</span>
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SurverYearReport);
